/* eslint-disable no-restricted-imports */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import {
  Button,
  makeStyles,
  TableFooter,
  TableCell,
  TableRow,
  CircularProgress,
} from "@material-ui/core";
import ListSubheader from "@material-ui/core/ListSubheader";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import { Pagination } from "react-bootstrap";
import { Dropdown } from "react-bootstrap";
import {
  getBotAdminList,
  getBotBookList,
  findLoginId,
  updateBookName,
  deleteBook,
  copyBook,
  getBookDetail,
} from "../modules/api";
import {
  DropdownCustomToggler,
  DropdownMenu4,
} from "../../_metronic/_partials/dropdowns";
import { ProgressBar, Modal, OverlayTrigger, Popover } from "react-bootstrap";
import { Link } from "react-router-dom";
import Moment from "moment";
import MUIDataTable from "mui-datatables";
import {
  validationEmail,
  validationPassword,
  validationPhoneNumber,
  validationBotId,
} from "../utils/validation";
import { isInteger } from "formik";

import InboxIcon from "@material-ui/icons/MoveToInbox";
import DraftsIcon from "@material-ui/icons/Drafts";
import SendIcon from "@material-ui/icons/Send";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import StarBorder from "@material-ui/icons/StarBorder";
import arwClose from "../info/assets/img/arw_close.svg";

export function BookSys() {
    let dest;
    let destBotId;
    let destBookList;
    let source;
    let sourceName;
    let sourceId;
    let sourceBot;
    let bookNameClass;

    const setBookNameClass = (className) => {
        bookNameClass = className;
    };

  const [open, setOpen] = React.useState(false);
  const [open2, setOpen2] = React.useState(false);
  const [isShow, setIsShow] = useState(false);
  const [isShowAttach, setIsShowAttach] = useState(false);
  const [list, setList] = useState();
  const [botAdminList, setBotAdminList] = useState([]);
  const [bookNo, setBookNo] = useState();
  const [bookName, setBookName] = useState();
  const [botAdminId, setBotAdminId] = useState();

  const [input, setInput] = useState({
    runCount: 0,
    successRate: 0,
    averageTime: 0,
    uploadAt: "",
    attachFileNames: "",
  });

  const handleClick = (index) => {
    let newData = list;
    newData[index].open = !newData[index].open;
    setList([...newData]);
  };
  const handleClick2 = (index, index2) => {
    let newData = list;
    newData[index].bookList[index2].open = !newData[index].bookList[index2]
      .open;
    setList([...newData]);
  };

  const getData = async (value, selectAdminId = false) => {
    const res = await getBotBookList(value);
      console.log(res);

      if (res.data !== undefined && res.data.length > 0) {
          const newList = res.data.map((item) => {
              item.open = false;
              return item;
          });

          if (!selectAdminId) {
              //과거 open했던 이력들을 복사함(업데이트나 삭제 시 초기화 안되게)
              if (list !== undefined && list != null) {
                  list.map((item, index) => {
                      if (item.open !== undefined && item.open) {
                          if (newList.find(item2 => item2.loginId == item.loginId).open !== undefined) {
                              newList.find(item2 => item2.loginId == item.loginId).open = true;
                          }
                      }
                  });
              }
          }
          
          setList(newList);
      }
  };
  useEffect(() => {
    // getData();
    fetchData();
  }, []);
    const onDragEnd = async () => {
        if (sourceId == destBotId || destBotId === undefined || destBotId === "") {
            return;
        }
        if (window.confirm(sourceName + " 북을 " + destBotId + " 계정으로 복사 하시겠습니까?")) {
            const param = {
                copyToBotNo: dest,
                no: source,
            };

            const res = await copyBook(param);
            const item = list.find(item => item.loginId == destBotId);

            let cnt = 0;
            let copySourceName = sourceName;
            //동일 이름이 있을 시 이름 계속해서 변경함
            if (item !== undefined && item !== null) {
                while (item.bookList.some(v => (v.name === copySourceName))) {
                    cnt = cnt + 1;
                    copySourceName = sourceName + "(" + cnt + ")";
                }
                if (cnt > 0) {
                    const param = {
                        name: copySourceName,
                    };
                    const res2 = await updateBookName(res.data.no, param);
                }
            }

            if (res.result) {
                alert(sourceName + " 북이 " + destBotId + " 계정으로 정상 복사 되었습니다.");

                destBotId = "";
                getData();
            } else {
                alert(sourceName + " 북이 " + destBotId + " 계정으로 복사 중 실패 하였습니다.");

                destBotId = "";
                return false;
            }
        }
        destBotId = "";
    };

  const fetchData = async () => {
    try {
      const botAdminList = await findLoginId();
      console.log("botAdminList", botAdminList);
      setBotAdminList(botAdminList.data);
    } catch (e) {
      console.log(e);
      // Handle error
    }
  };

  const toggleShow = () => {
    setIsShow(!isShow);
  };

  const toggleAttach = () => {
    setIsShowAttach(!isShowAttach);
  };

  const selectBotAdmin = (e) => {
    setBookName(null);
    getData(e.target.value, true);
    setBotAdminId(e.target.value);
  };

  const uptBookName = async () => {
    toggleShow();
    const param = {
      name: bookName,
    };
    const res = await updateBookName(bookNo, param);
    if (res.result) {
      alert("정상적으로 수정되었습니다.");
      getData(botAdminId);
    } else {
      alert("정상적으로 수정되지 않았습니다.");
      return false;
    }
  };

    const delBook = async () => {
        if (window.confirm(bookName + " 북을 삭제하시겠습니까?")) {
            const res = await deleteBook(bookNo);
            if (res.result) {
                alert("정상적으로 삭제되었습니다.");
                setBookName(null);
                getData(botAdminId);

            } else {
                alert("정상적으로 삭제되지 않았습니다.");
                return;
            }
        }
    };

  const bookDetail = async (value) => {
    const res = await getBookDetail(value);
    console.log("resresres", res);

    setInput({
      runCount: res.data.runCount,
      averageTime: res.data.averageTime,
      successRate: parseInt(
        isNaN((res.data.successCount / res.data.runCount) * 100)
          ? 0
          : (res.data.successCount / res.data.runCount) * 100
      ),
      uploadAt: Moment(res.data.createdAt).format("YYYY-MM-DD HH:mm:ss"),
      attachFileNames: res.data.attachFileNames,
    });
  };

  return (
      <div id="pageid31">
          <Modal show={isShow}>
              <Modal.Header closeButton>
                  <Modal.Title id="example-modal-sizes-title-lg">
                      북 이름 변경
          </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                  <p>북 이름</p>
                  <div className="form-group fv-plugins-icon-container">
                      <div className="d-flex align-items-center justify-content-between">
                          <input
                              placeholder=""
                              type="text"
                              className={`form-control form-control-solid h-auto py-5 px-6 `}
                              name="bookName"
                              onChange={(e) => setBookName(e.target.value)}
                              value={bookName}
                          />
                      </div>
                  </div>
              </Modal.Body>
              <Modal.Footer>
                  <div>
                      <button
                          type="button"
                          onClick={toggleShow}
                          className="btn btn-light btn-elevate"
                      >
                          취소
            </button>
                      <> </>
                      <button
                          type="button"
                          onClick={uptBookName}
                          className="btn btn-primary btn-elevate"
                      >
                          확인
            </button>
                  </div>
              </Modal.Footer>
          </Modal>
          <Modal show={isShowAttach}>
              <Modal.Header closeButton>
                  <Modal.Title id="example-modal-sizes-title-lg">
                      {bookName} 첨부파일
          </Modal.Title>
              </Modal.Header>
              <Modal.Body className="px-5">
                  <table>
                      <thead>
                          <tr>
                              <th>파일명</th>
                          </tr>
                      </thead>
                      <tbody>
                          {!input.attachFileNames && (
                              <tr>
                                  <td>
                                      <span>내역이 없습니다.</span>
                                  </td>
                              </tr>
                          )}
                          {input.attachFileNames &&
                              input.attachFileNames.split(",").map((data, index) => {
                                  return (
                                      <tr>
                                          <td>{data}</td>
                                      </tr>
                                  );
                              })}
                          {input.attachFileNames &&
                              input.attachFileNames.split(",").length === 0 && (
                                  <tr>
                                      <td>
                                          <span>내역이 없습니다.</span>
                                      </td>
                                  </tr>
                              )}
                      </tbody>
                  </table>
              </Modal.Body>
              <Modal.Footer>
                  <div>
                      <button
                          type="button"
                          onClick={() => {
                              toggleAttach();
                          }}
                          className="btn btn-primary btn-elevate"
                      >
                          확인
            </button>
                  </div>
              </Modal.Footer>
          </Modal>
          <div className="top-row gutter-b d-flex align-items-center flex-column">
              <div
                  className="d-flex align-items-center justify-content-between w-100"
                  style={{ marginTop: 30 }}
              >
                  <h3 className="card-label font-weight-bolder text-dark d-flex align-items-center mb-0">
                      북 관리
          </h3>
                  <div className="fv-plugins-icon-container mr-5">
                      <select
                          className="form-control form-control-lg form-control-solid"
                          style={{ borderColor: "black", width: "200px" }}
                          name="botAdminList"
                          onChange={(e) => selectBotAdmin(e)}
                      >
                          <option value="">선택</option>
                          {botAdminList &&
                              botAdminList.length > 0 &&
                              botAdminList.map((data, index) => {
                                  return <option value={data.no}>{data.loginId}</option>;
                              })}
                      </select>
                  </div>
              </div>
          </div>
          <div className="gutter-b" style={{ marginTop: 50, display: "flex" }}>
              <div class="sideNav">
                  <div class="tab">
                      <span>Bot ID 별 북 리스트</span>
                  </div>
                  <div id="evrecipe" class="tabcontent">
                      <div class="tabcontent-group">
                          <div class="tabcontent-btn-group">
                              <div class="tabcontent-btn-group-ovf">
                                  <div class="dropdown-container">
                                      <List
                                          component="nav"
                                          aria-labelledby="nested-list-subheader"
                                          style={{
                                          }}
                                      >
                                          {list &&
                                              list.map((item, index) => {
                                                  return (
                                                      <div key={index}>
                                                          <ListItem
                                                              style={{ paddingLeft: "10px", paddingRight: "2px" }}
                                                              onClick={() => handleClick(index)}
                                                              onDragOver={(e) => {
                                                                  e.preventDefault();
                                                                  console.log("end", e.target);
                                                                  dest = e.currentTarget.dataset.botno;
                                                                  destBotId = e.currentTarget.dataset.botid;
                                                                  destBookList = e.currentTarget.dataset.booklist;
                                                              }}
                                                              data-botno={item.no}
                                                              data-botid={item.loginId}
                                                              data-booklist={item.bookList}
                                                          >
                                                              {item.open ? (
                                                                  <div class="dropdown-btn open" data-botno={item.no}>
                                                                      {item.loginId}
                                                                      <img src={arwClose} class="navMenuSubMenuArw open" />
                                                                  </div>

                                                              ) :
                                                                  (
                                                                      <div class="dropdown-btn" data-botno={item.no}>
                                                                          {item.loginId}
                                                                          <img src={arwClose} class="navMenuSubMenuArw" />
                                                                      </div>

                                                                  )
                                                              }
                                                          </ListItem>
                                                          <Collapse in={item.open} timeout="auto" unmountOnExit>
                                                              {item.bookList.map((item2, index2) => {
                                                                  return (
                                                                      <>
                                                                          <List component="div" disablePadding>
                                                                              <ListItem style={{ paddingLeft: "20px" }}>
                                                                                  {bookNo == item2.no ? setBookNameClass("bookName active") : setBookNameClass("bookName")}
                                                                                  <div
                                                                                      style={{
                                                                                          fontSize: "13px",

                                                                                      }}
                                                                                      class={bookNameClass}
                                                                                      draggable={true}
                                                                                      onDragEnd={(e) => {
                                                                                          // console.log(e.target);
                                                                                          source = e.currentTarget.dataset.bookno;
                                                                                          sourceName = e.currentTarget.dataset.bookname;
                                                                                          sourceId = e.currentTarget.dataset.botid;
                                                                                          // console.log("source", source);
                                                                                          onDragEnd();
                                                                                      }}
                                                                                      data-bookno={item2.no}
                                                                                      data-bookname={item2.name}
                                                                                      data-botid={item.loginId}
                                                                                      onClick={() => {
                                                                                          setBookNo(item2.no);
                                                                                          setBookName(item2.name);
                                                                                          bookDetail(item2.no);
                                                                                      }}
                                                                                  >
                                                                                      {item2.name}
                                                                                  </div>
                                                                                  {/* {item2.open ? <ExpandLess /> : <ExpandMore />} */}

                                                                              </ListItem>
                                                                          </List>
                                                                      </>
                                                                  );
                                                              })}
                                                          </Collapse>
                                                      </div>
                                                  );
                                              })}
                                      </List>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="content">
                  <div class="controlPanel">

                      {bookName != null &&
                          <div class="controlPanelHeader">
                              <div class="title">
                                  <div class="bookName">
                                      <span>{bookName}</span>
                                  </div>

                                  <div class="btn-contents">
                                      <button class="btn btn-secondary" type="button" onClick={toggleShow}>북 이름 변경</button>
                                      <button class="btn btn-danger" type="button" onClick={() => delBook()}>삭제</button>
                                  </div>
                              </div>
                              <div class="row dashboard-top-btn-row justify-content-between" style={{ display: "flex", marginLeft: "50px", paddingTop: "30px" }}>
                                  <div className="col-lg-3 gutter-b">
                                      <Button
                                          className={`btn font-weight-bold text-white px-9 py-7 w-100 justify-content-between`}
                                      >
                                          <div className="text text-left">
                                              {/* <h1>{todayTotalExeCount}</h1> */}
                                              <h1>{input.runCount}건</h1>
                                              <h6 className="mb-0">실행</h6>
                                          </div>
                                          <div className="icon">
                                              <span className="svg-icon svg-icon-xxl">
                                                  <SVG
                                                      src={toAbsoluteUrl("/media/svg/icons/Home/Book.svg")}
                                                  />
                                              </span>
                                          </div>
                                      </Button>
                                  </div>
                                  <div className="col-lg-3 gutter-b">
                                      <Button
                                          className={`btn font-weight-bold text-white px-9 py-7 w-100 justify-content-between`}
                                      >
                                          <div className="text text-left">
                                              {/* <h1>{Math.round(isNaN(exeRate) ? 0 : exeRate)}</h1> */}
                                              <h1>{input.successRate}%</h1>
                                              <h6 className="mb-0">성공률</h6>
                                          </div>
                                          <div className="icon">
                                              <span className="svg-icon svg-icon-xxl">
                                                  <SVG
                                                      src={toAbsoluteUrl(
                                                          "/media/svg/icons/Navigation/Angle-double-right.svg"
                                                      )}
                                                  />
                                              </span>
                                          </div>
                                      </Button>
                                  </div>

                                  <div className="col-lg-3 gutter-b">
                                      <Button
                                          className={`btn font-weight-bold text-white px-9 py-7 w-100 justify-content-between`}
                                      >
                                          <div className="text text-left">
                                              {/* <h1>{botList2.length}</h1> */}
                                              <h1>{input.averageTime}</h1>
                                              <h6 className="mb-0">평균 수행시간</h6>
                                          </div>
                                          <div className="icon">
                                              <span className="svg-icon svg-icon-xxl">
                                                  <SVG
                                                      src={toAbsoluteUrl(
                                                          "/media/svg/icons/Electric/Gas-stove.svg"
                                                      )}
                                                  />
                                              </span>
                                          </div>
                                      </Button>
                                  </div>

                                  <div className="col-lg-3 gutter-b" style={{ marginTop: "20px" }}>
                                      <span style={{ color: "black" }}>
                                          업로드 일시 {input.uploadAt}
                                      </span>
                                      <div
                                          style={{
                                              marginTop: "14px",
                                              textDecoration: "underline",
                                              cursor: "pointer"
                                          }}
                                          onClick={toggleAttach}
                                      >
                                          첨부파일 보기
                </div>
                                  </div>
                              </div>
                          </div>
                      }

                      <div class="controlPanelBody">

                      </div>
                  </div>
              </div>
          </div>
      </div>
  );
}
export default BookSys;
